import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ to }) => {
  const navigate = useNavigate();

  return <ChevronLeft size={45} onClick={() => navigate(to || -1)} />;
};

export default BackButton;
